import { makeStyles } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

export const useSavedLaneRowStyles = makeStyles(theme => ({
  card: {
    '&:hover': {
      backgroundColor: brandColors.coolGray1,
      cursor: 'pointer',
    },
  },
  mainBox: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  boxStyle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: `${theme.spacing(2)} 0 ${theme.spacing(2)} ${theme.spacing(2)}`,
    [theme.breakpoints.down('md')]: {
      padding: `${theme.spacing(2)} ${theme.spacing(1.5)}`,
    },
  },
  laneContainer: {
    margin: `0 0 ${theme.spacing(0.5)} 0`,
  },
  detailsContainer: {
    margin: `0 0 ${theme.spacing(0.5)} 0`,
  },
  menuBox: {
    display: 'flex',
    alignItems: 'center',
    padding: `0 ${theme.spacing(2)} 0 0`,
    [theme.breakpoints.down('md')]: {
      justifyContent: 'space-between',
      borderTop: `1px solid ${brandColors.coolGray2}`,
      padding: `${theme.spacing(2.5)} ${theme.spacing(2)}`,
    },
    [theme.breakpoints.up('sm')]: {
      gap: '12px',
    },
  },
}))
